const e = new URL("../../../assets/image-title-baseline-DacZ-rpb.png", import.meta.url).href;
export {
  e as default
};
//# sourceMappingURL=image-title-baseline.png.js.map
